export const AdminUsersDetailsPermissions = {
  AdminUsersDetailsPermissions: {
    permissionsId: "ed6e5644-eec3-4dcd-f94f-08dc0f48c1d2",
    permissionsName: "Users Details",
    description: null,
    componentsId: null,
    components: null
  },
};
